export default __webpack_public_path__ + "static/media/swap.ff1e2d00.png";